import CategoryPage from "./CategoryPage";

export default function MoviesPage() {
  return (
    <CategoryPage
      title="Movies"
      layout="portrait"
      pick={(c) => ({ streams: c.vod.streams, categories: c.vod.categories })}
    />
  );
}
